module.exports = __webpack_public_path__ + "static/Laura-fd9d3082c1bd6bdd780a9fa87b678d14.png";